<template>
  <v-card-subtitle>
    Sequencer will stop here
  </v-card-subtitle>
</template>
<script>
export default {
  props: {
    action: {
      type: Object,
      required: true
    }
  }
}
</script>